import axios from '@/backend/axios'

export default {
  async login(credentials) {
    return await axios.post('/account/login', credentials)
  },
  async loginAdmin(credentials){
    return await axios.post('/v2/admin/login', credentials)
  },

  async validate(token){
    const req= {token:token}
    return await axios.post('account/validate',req)
    //.then((response) => {
  //     console.log('Validate respo:' + response.data)
  //     return response
  //  })
  },

  async validateAdmin(token){
    const req= {token:token}
    return await axios.post('/v2/admin/validate',req)
    //.then((response) => {
  //     console.log('Validate respo:' + response.data)
  //     return response
  //  })
  },
  async refresh(oldToken, refreshToken){
    var req = {
      token: oldToken,
      refreshToken: refreshToken,
    }
    return await axios.post('account/validate',req)
  },
  
  async getPapers(paperType, reportState) {
    var req = {
      reportState: reportState,
      paperType: paperType,
    }
    //return await axios.get(`/report/notReportedByType/${paperType}`)
    return await axios.post('/paper/getPapers', req)
  },

  async getReportedPapers() {
    return await axios.get('/report/reported')
  },

  async getOpenBundles(paperType) {
    return await axios.get(`/bundle/open/${paperType}`)
  },  

  async addPapers(bundleId, paper, amount) {
    const req = {
      titleId: paper.titleId,
      editionId: paper.editionId,
      deliveryDate: paper.deliveryDate,
      amount: amount
    }
    return axios.post(`/report/${bundleId}/add`, req)
  },

  async closeBundle(bundleId) {    
    return await axios.post(`/bundle/${bundleId}/close`)
  },

  async getBundle(bundleId) {
    return await axios.get(`/bundle/${bundleId}`)
  },


  async orderBundle(type, amount) {
    let req = null
    if(type !== undefined)
    {
      req = {
        type:type,
        amount: amount
      }
    }
    return await axios.post('/bundle/order',req)
  },

  async getBundleBlocks(){
    return await axios.get('/bundle/blocks')
  },
  async getHistoricBundles(dates){
    let req = {
      startDateTime:dates[0],
      endDateTime:dates[1]
    }
    return await axios.post('/bundle/historic',req)
  },

  async getDelivery() {
    return await axios.get('/delivery')
  },

  async saveDelivery(delivery) {
    return await axios.post('/delivery', delivery)
  },

  async getMessages() {
    return await axios.get('/customer/messages')
  },
  async getCustomersMessages(type){    
    return await axios.get(`messages/${type}`)
  },
  async getHolidays(history) {
    return await axios.get(`/holiday/list/${history}`)
  },

  async saveHoliday(holiday) {
    return await axios.post('/holiday/save', holiday)
  },

  async getPaperInfo(publisher) {
    return await axios.get(`/paper/paperInfo/${publisher}`)
  },

  async getAllPaperInfo() {
    return await axios.get('/paper/paperInfo')
  },

  async getAlerts() {
    return await axios.get('/alerts')
  },

  async getInvoices(provider) {   
    return await axios.get(`/invoice/${provider}`)
  },

  async getInvoice(provider,id) {       
    return await axios.get(`/invoice/file/${provider}/${id}`)
  },

  async getDistribution(startDate,stopDate) {
    return await axios.get(`distribution/${startDate}/${stopDate}`)
  },

  async getPaperList(startDate,stopDate) {
    return await axios.get(`paper/${startDate}/${stopDate}`)
  },

  async getPlacards() {
    return await axios.get('placard')
  },
  async savePlacard(placard) {
    return await axios.post('placard',placard)
  },

  async getGuarantee(){
    return await axios.get('invoice/guarantee')   
  }

}
